<template>
  <main class="clinic-login">
    <div
      class="clinic-login__layout"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot',
      }"
      id="kt_login"
    >
      <section
        class="clinic-login__identity"
        aria-label="Sistema Clínico Universitario"
      >
        <div class="clinic-login__brand">
          <span class="clinic-login__brand-mark" aria-hidden="true"></span>
          <span>CLÍNICAS</span>
        </div>

        <div class="clinic-login__identity-content">
          <img
            :src="backgroundImage"
            class="clinic-login__logo"
            alt="Universidad Interamericana - Facultad de Medicina"
          />
          <h1>Sistema Clínico<br /></h1>
          <p>
            Gestión de pacientes, agendas y prácticas clínicas de<br
              class="clinic-login__desktop-break"
            />
            la carrera de Medicina — Ley Nº 4200/2010.
          </p>
        </div>

        <footer class="clinic-login__identity-footer">
          <span>Pedro Juan Caballero · Paraguay</span>
          <span>Educación de calidad sin fronteras</span>
        </footer>
      </section>

      <section class="clinic-login__access">
        <div class="clinic-login__access-inner">
          <div class="clinic-login__mobile-brand">
            <img
              src="/media/logos/logo_colorido_interamericana.png"
              class="clinic-login__mobile-logo"
              alt="Universidad Interamericana - Facultad de Medicina"
            />
          </div>

          <div class="login-form login-signin clinic-login__form-wrapper">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitLogin()"
            >
              <header class="clinic-login__form-header">
                <span class="clinic-login__eyebrow">ACCESO CLÍNICAS</span>
                <h2>Universidad Interamericana</h2>
                <p>Ingresá con tus credenciales para continuar.</p>
              </header>

              <div class="form-group clinic-login__field">
                <label for="clinic-login-user"
                  >Usuario o correo de registro</label
                >
                <div
                  id="example-input-group-1"
                  label=""
                  label-for="clinic-login-user"
                >
                  <input
                    id="clinic-login-user"
                    class="form-control"
                    type="text"
                    name="login"
                    ref="login"
                    v-model="form.login"
                    placeholder="nombre.apellido@uni.edu.py"
                  />
                </div>
              </div>

              <div class="form-group clinic-login__field">
                <label for="clinic-login-password">Contraseña</label>
                <div
                  id="example-input-group-2"
                  label=""
                  label-for="clinic-login-password"
                >
                  <input
                    id="clinic-login-password"
                    class="form-control"
                    type="password"
                    name="password"
                    ref="password"
                    v-model="form.password"
                    autocomplete="off"
                    placeholder="Ingresá tu contraseña"
                  />
                </div>
              </div>

              <div class="clinic-login__form-meta">
                <span>Acceso seguro</span>
                <!-- <span>Credenciales institucionales</span> -->
              </div>

              <div class="clinic-login__submit">
                <button
                  ref="kt_login_signin_submit"
                  class="btn clinic-login__button"
                  :class="{ 'spinner spinner-light spinner-right': loading }"
                  :disabled="loading"
                >
                  Entrar al sistema
                </button>
              </div>

              <aside class="clinic-login__notice">
                El acceso está restringido a personal autorizado. Toda actividad
                es registrada conforme a las políticas de confidencialidad de
                datos clínicos.
              </aside>
            </form>
          </div>

          <footer class="clinic-login__access-footer">
            © 2026 Universidad Interamericana · Facultad de Medicina
          </footer>
        </div>
      </section>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.clinic-login {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f8fafc;
  color: #101828;
  font-family: "Poppins", sans-serif;

  &__layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    min-height: inherit;
  }

  &__identity {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: inherit;
    padding: clamp(32px, 4vw, 72px) clamp(36px, 5vw, 92px) 30px;
    color: #ffffff;
    background: radial-gradient(
        circle at 96% 68%,
        rgba(117, 46, 87, 0.32),
        transparent 31%
      ),
      radial-gradient(
        circle at 74% 103%,
        rgba(0, 130, 143, 0.28),
        transparent 27%
      ),
      linear-gradient(135deg, #173a78 0%, #091a46 51%, #0b1a3e 100%);
  }

  &__identity::after {
    position: absolute;
    right: -18%;
    bottom: -34%;
    width: 72%;
    padding-bottom: 72%;
    content: "";
    border-radius: 50%;
    background: rgba(15, 112, 131, 0.08);
    filter: blur(10px);
  }

  &__brand,
  &__mobile-brand {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.3em;
  }

  &__brand-mark {
    display: inline-block;
    width: 6px;
    height: 34px;
    border-radius: 10px;
    background: #ef3e36;
  }

  &__identity-content {
    position: relative;
    z-index: 1;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 3vh;
    text-align: center;
  }

  &__logo {
    width: clamp(215px, 18vw, 310px);
    max-height: 290px;
    margin-bottom: clamp(24px, 3.2vh, 42px);
    object-fit: contain;
  }

  &__identity-content h1 {
    margin: 0 0 20px;
    color: #ffffff;
    font-size: clamp(31px, 2.5vw, 48px);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.035em;
  }

  &__identity-content p {
    margin: 0;
    color: rgba(224, 232, 247, 0.72);
    font-size: clamp(13px, 1vw, 16px);
    line-height: 1.65;
  }

  &__identity-footer {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    color: rgba(224, 232, 247, 0.65);
    font-size: 12px;
  }

  &__access {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: inherit;
    padding: 44px clamp(28px, 7vw, 140px);
    background: #fbfcfe;
  }

  &__access-inner {
    display: flex;
    width: 100%;
    max-width: 450px;
    min-height: min(680px, calc(100vh - 88px));
    flex-direction: column;
    justify-content: center;
  }

  &__mobile-brand {
    display: none;
    margin-bottom: 42px;
    color: #163875;
  }

  &__mobile-logo {
    display: block;
    width: 138px;
    height: auto;
    margin: 0 auto;
    object-fit: contain;
  }

  &__form-wrapper {
    width: 100%;
  }

  &__form-header {
    margin-bottom: 42px;
  }

  &__eyebrow {
    display: block;
    margin-bottom: 13px;
    color: #e93632;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.28em;
  }

  &__form-header h2 {
    margin: 0 0 8px;
    color: #0b1220;
    font-size: clamp(27px, 2.15vw, 36px);
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.04em;
  }

  &__form-header p {
    margin: 0;
    color: #71809d;
    font-size: 15px;
  }

  &__field {
    margin-bottom: 22px;
  }

  &__field label {
    display: block;
    margin-bottom: 8px;
    color: #161d2d;
    font-size: 13px;
    font-weight: 600;
  }

  &__field .form-control {
    height: 52px;
    padding: 0 17px;
    border: 1px solid #d9e1ed;
    border-radius: 14px;
    color: #172033;
    background: #f3f6fb;
    box-shadow: none;
    font-size: 14px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background-color 0.2s ease;
  }

  &__field .form-control::placeholder {
    color: #8190aa;
  }

  &__field .form-control:focus {
    border-color: #2b63c6;
    background: #ffffff;
    box-shadow: 0 0 0 4px rgba(43, 99, 198, 0.16);
  }

  &__form-meta {
    display: flex;
    justify-content: space-between;
    margin: 2px 0 20px;
    color: #72809a;
    font-size: 12px;
  }

  &__submit {
    width: 100%;
  }

  &__button.btn {
    width: 100%;
    min-height: 52px;
    border: 0;
    border-radius: 14px;
    color: #ffffff;
    background: #2860c2;
    box-shadow: 0 10px 22px rgba(40, 96, 194, 0.2);
    font-size: 14px;
    font-weight: 600;
    transition: transform 0.2s ease, background-color 0.2s ease,
      box-shadow 0.2s ease;
  }

  &__button.btn:hover,
  &__button.btn:focus {
    color: #ffffff;
    background: #1f50a8;
    box-shadow: 0 12px 26px rgba(40, 96, 194, 0.28);
    transform: translateY(-1px);
  }

  &__button.btn:disabled {
    cursor: wait;
    opacity: 0.75;
    transform: none;
  }

  &__notice {
    margin-top: 32px;
    padding: 17px 18px;
    border: 1px solid #dbe3ef;
    border-radius: 14px;
    color: #6f7f9b;
    background: #f5f8fc;
    font-size: 11px;
    line-height: 1.65;
  }

  &__access-footer {
    margin-top: 34px;
    color: #7b89a2;
    font-size: 11px;
    text-align: center;
  }
}

@media (max-width: 991.98px) {
  .clinic-login {
    &__layout {
      grid-template-columns: 1fr;
    }

    &__identity {
      display: none;
    }

    &__access {
      padding: 34px 24px;
      background: linear-gradient(
          180deg,
          rgba(20, 55, 116, 0.05),
          transparent 200px
        ),
        #fbfcfe;
    }

    &__access-inner {
      max-width: 470px;
      min-height: calc(100vh - 68px);
    }

    &__mobile-brand {
      display: flex;
    }
  }
}

@media (max-width: 575.98px) {
  .clinic-login {
    &__access {
      align-items: flex-start;
      padding: 24px 18px 28px;
    }

    &__access-inner {
      min-height: calc(100vh - 52px);
      justify-content: flex-start;
    }

    &__mobile-brand {
      margin-bottom: 54px;
    }

    &__mobile-logo {
      width: 112px;
    }

    &__form-header {
      margin-bottom: 34px;
    }

    &__form-header h2 {
      font-size: 27px;
    }

    &__form-header p {
      font-size: 13px;
    }

    &__form-meta {
      font-size: 10px;
    }

    &__notice {
      margin-top: 26px;
    }

    &__access-footer {
      margin-top: auto;
      padding-top: 32px;
    }
  }
}
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      loading: false,
      form: {
        login: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    // backgroundImage() {
    //   return (
    //     process.env.BASE_URL + "media/svg/illustrations/logo7.png"
    //   );
    backgroundImage() {
      return (
        process.env.BASE_URL + "media/logos/logo_principal_branco_inter.png"
      );
    },
  },
  mounted() {
    const signin_form = KTUtil.getById("kt_login_signin_form");

    this.fv = formValidation(signin_form, {
      fields: {
        login: {
          validators: {
            notEmpty: {
              message: "Username is required",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });
  },
  methods: {
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },

    onSubmitLogin() {
      this.$store.dispatch(LOGOUT);
      this.loading = true;
      this.$store
        .dispatch(LOGIN, this.form)
        .then(() => this.$router.push({ name: "dashboard" }))
        .catch((error) => {
          if (error.response.status == 503) {

            Swal.fire({
              title: "AVISO",
              text: error.response.data.error,
              
            });
          } else {
            Swal.fire({
              title: "Datos incorrectos!",
              text: "Confirme sus datos e intente de nuevamente.",
              icon: "Error",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
